import React from 'react';
//@ts-ignore
import { parse } from 'query-string';
import { LayoutHandler } from '@food/ui/build/dist/src/LayoutHandler';
import { socialLoginFactory, socialLoginLayoutChooser, } from './SocialLogin';
import { isLogged } from '../index';
import { useLocation } from 'react-router-dom';
export var Login = function (_a) {
    var t = _a.t, container = _a.container, onRedirect = _a.onRedirect, authManager = _a.authManager, config = _a.config, tokens = _a.tokens;
    var SocialLogin = React.useMemo(function () { return socialLoginFactory(t); }, [t]);
    var Container = React.useMemo(function () { return container || (function (_a) {
        var children = _a.children;
        return children;
    }); }, [container]);
    var location = useLocation();
    var redirectUrl = parse(location.search).redirect || config.DEFAULT_LOGGED_ROUTE || '/';
    var params = parse(location.search);
    var traditional = params.traditional, social = params.social, upgraderole = params.upgraderole;
    if (isLogged() &&
        !upgraderole &&
        !tokens.workEmailVerifyToken &&
        !tokens.sfContactId) {
        onRedirect({}, redirectUrl);
        return null;
    }
    return (React.createElement(Container, null,
        React.createElement(LayoutHandler, { layouts: { main: socialLoginLayoutChooser } }, function (layouts) { return (React.createElement(SocialLogin, { tokens: tokens, layout: layouts.main, isModal: false, authManager: authManager, logo: config.LOGO, config: config, startTraditional: (!!traditional || config.LOGIN_START_TRADITIONAL) &&
                !social, instantUpgradeRole: upgraderole })); })));
};
//# sourceMappingURL=Login.js.map